import databaseLayers from './databaselayers'
import geoportal from './geoportal'
import giscube from './giscube'

export default {
  databaseLayers,
  geoportal,
  giscube
}
